import general from "./../general/general";

const getSurveyByWorkplace = async (workplace, type) => (
  await general.callApi("survey/", "GET", {
    workplace: workplace,
    survey_type: type,
  })
);

const getSurveyByPatientGroup = async (patientGroup, type) => (
  await general.callApi("survey/", "GET", {
    patient_group__name: patientGroup,
    survey_type: type,
  })
);

const validateSurvey = async (surveyId, answers) => {
  return await general.callApi(
    `survey/${surveyId}/validate/`,
    "POST",
    {
      ...answers,
    }
  );
};

const submitSurvey = async (surveyId, appointmentId, answers) => {
  return await general.callApi(
    `survey/${surveyId}/result/${appointmentId}/`,
    "POST",
    {
      ...answers,
    }
  );
};

export {
  getSurveyByWorkplace,
  getSurveyByPatientGroup,
  validateSurvey,
  submitSurvey,
};
